export default __webpack_public_path__ + "static/media/error-red.bdc32f49.svg";